import { cn } from '../../lib/utils';

// ----------------------------------------------------------------------
export const DASHBOARD_CHART_HEIGHT = 260;
export const DASHBOARD_LEGEND_HEIGHT = 60;
export const DASHBOARD_CHART_HEIGHT_SMALL = (DASHBOARD_CHART_HEIGHT + DASHBOARD_LEGEND_HEIGHT) / 2;
/** Shorter height for YTD stat cards (Net Income, Occupancy, Bookings) */
export const DASHBOARD_STAT_CARD_HEIGHT = 112;

interface StyledWidgetChartProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export default function StyledWidgetChart({
  children,
  className,
  ...props
}: StyledWidgetChartProps) {
  return (
    <div
      className={cn('relative mt-2', className)}
      style={{ height: DASHBOARD_CHART_HEIGHT }}
      {...props}
    >
      <div className="widget-chart">{children}</div>
    </div>
  );
}
